// extracted by mini-css-extract-plugin
export default {"Game":"Game_Game__9YC5K","Singles":"Game_Singles__rUNwC","Winner":"Game_Winner__SeZQf"};